import { LadiesMain } from "../../global/ladies-main"
import { InfoPanel } from "../../info-panel/InfoPanel"
import { openGenericModal } from "../../util/generic-modal"

export default class StarsPostsRoses {
    constructor(/** jQuery */ jQuery) {
        this.$ = jQuery

        this.rosesApiUrl = `${SiteInfo.yiiLadiesApiUrl}/v1/StarsRoses/buy`
        this.starsSeparationRosesApiUrForCreator = `${SiteInfo.starsApiUrl}/api/roses-http-api/command/purchase-for-creator`
        this.starsSeparationRosesApiUrForPost = `${SiteInfo.starsApiUrl}/api/roses-http-api/command/purchase-for-post`

        this.configureRosesModal = document.getElementById("configureRosesModal")
        this.buyRosesModal = document.getElementById("buyRosesModal")
        this.cancelRosesButtons = document.getElementsByClassName("btn-cancel")
        this.purchaseRosesButton = document.getElementById("enoughCoins")
        this.rosesBuyButtonStandardTextTmp = ""
        this.continueToBuyRosesButton = document.getElementById("continueToBuyRosesButton")
        if (this.purchaseRosesButton) {
            this.rosesBuyButtonStandardTextTmp = this.purchaseRosesButton.innerHTML
        }
        this.currentCoins = userData.userCoinAmount

        this.rosesModalBuyButtons = document.getElementById("subscriptionModalBuyButtons")
        this.setRosesCountButtons = document.getElementsByClassName("stars-roses-button")
        this.rosesCountInput = document.getElementById("rosesAmountDataTag")
        this.rosesFormData = new FormData()

        new Promise((resolve) => this.addEventListeners(resolve)).then(() => {
            this.saveCurrentCoinBalanceInStorage(this.userCurrentCoinBalanceInDom())
        })

        this.reopenModals()
    }

    addEventListeners(/** Function */ resolve) {
        /** void */
        if (!this.rosesCountInput) {
            return
        }

        window.addEventListener("storage", (/** StorageEvent */ event) => {
            if (event && event.key === "userCurrentCoinBalance") {
                this.userCurrentCoinBalanceInDom(Number.parseInt(event.newValue))
                this.closeRosesModalAndClearState()
            }
        })

        // Bootstrap modal events only work with jQuery
        $(this.configureRosesModal).on("show.bs.modal", (/** jQuery.Event */ modalEvent) =>
            this.showRosesModalContent(modalEvent),
        )

        $(this.configureRosesModal).on("hide.bs.modal", (/** jQuery.Event */ modalEvent) =>
            this.hideRosesModalContent(modalEvent),
        )

        $(this.buyRosesModal).on("show.bs.modal", (/** jQuery.Event */ modalEvent) =>
            this.showBuyRosesModal(modalEvent),
        )

        $(this.buyRosesModal).on("hide.bs.modal", (/** jQuery.Event */ modalEvent) =>
            this.hideBuyRosesModal(modalEvent),
        )

        this.rosesCountInput.addEventListener("input", this.updateCoinsCount.bind(this))

        if (this.continueToBuyRosesButton) {
            this.continueToBuyRosesButton.addEventListener("click", this.continueToBuyRoses.bind(this))
        }

        if (this.setRosesCountButtons) {
            for (const btn of this.setRosesCountButtons) {
                btn.addEventListener("click", this.addOrSubstractRosesCount.bind(this))
            }
        }

        $(this.configureRosesModal).on("show.bs.modal hide.bs.modal", (/** jQuery.Event */ modalEvent) =>
            this.setUnsetOpenStarsModalClass(modalEvent),
        )

        $(".stars-roses-modal .icon-modal-close").click(
            function (e) {
                this.clearUrl()
            }.bind(this),
        )

        $("#configureRosesModal button.btn-cancel").click(
            function (e) {
                this.clearUrl()
            }.bind(this),
        )

        $("#buyRosesModal button.btn-cancel").click(
            ((e) => {
                $("#buyRosesModal").modal("hide")
                $("#configureRosesModal").modal("show")
            }).bind(this),
        )

        if (this.purchaseRosesButton) {
            this.purchaseRosesButton.addEventListener("click", this.purchaseRosesRequestInStarsSeparation.bind(this))
        }

        if (this.cancelRosesButtons) {
            for (const btn of this.cancelRosesButtons) {
                if (btn instanceof HTMLElement) {
                    btn.addEventListener(
                        "click",
                        function () {
                            $(this.buyRosesModal).modal("hide")
                        }.bind(this),
                    )
                }
            }
        }

        resolve()
    }

    clearUrl() {
        LadiesMain.removeHashtagFromUrl("post-id")
        LadiesMain.removeHashtagFromUrl("roses-count")
        LadiesMain.removeHashtagFromUrl("star-id")
        LadiesMain.removeHashtagFromUrl("configure-roses-modal")
        LadiesMain.removeHashtagFromUrl("purchase-roses-modal")
    }

    changeStateToRosesGiftedToPost(/** string */ postId, /** number */ addedRosesCount) {
        const giftRoseButton = document.querySelector(`.gift-roses-button[data-post-id="${postId}"]`)
        const rosesCounter = giftRoseButton.querySelector(".rose-count")
        const rosesLabel = giftRoseButton.querySelector(".roses-label")

        giftRoseButton.dataset.gifted = true
        rosesLabel.innerText = " • mehr schenken"

        rosesCounter.innerText = this.getActualRosesCountForPost(postId) + addedRosesCount
    }

    showBuyRosesModal(/** jQuery.Event */ modalEvent) {
        LadiesMain.addHashtagToUrl("purchase-roses-modal")

        let postId
        let starId

        postId = LadiesMain._getHashtagObject()["post-id"]
        starId = LadiesMain._getHashtagObject()["star-id"]

        try {
            this.updateBuyRosesModalWithCreatorData(postId, starId)
        } catch (e) {
            this.clearUrl()
            modalEvent.preventDefault()
            openGenericModal(
                "Die gewünschte Aktion ist nicht möglich.\n" +
                    "                            Lade bitte die Seite neu und versuche es erneut.\n" +
                    "                            Sollte es weiterhin nicht funktionieren, melde dich bitte bei unserem Support.",
                "Unzulässiger Vorgang",
            )
        }
    }

    hideBuyRosesModal(/** jQuery.Event */ modalEvent) {
        LadiesMain.removeHashtagFromUrl("purchase-roses-modal")
    }

    hideRosesModalContent(/** jQuery.Event */ modalEvent) {
        LadiesMain.removeHashtagFromUrl("configure-roses-modal")
    }

    /**
     * @privateLadiesMain.removeHashtagFromUrl('configure-roses-modal');
     */
    showRosesModalContent(/** jQuery.Event */ modalEvent) {
        if (this.configureRosesModal.closest("main") instanceof HTMLElement) {
            document.body.append(this.configureRosesModal)
        }

        let postId
        let starId

        if (!modalEvent || !modalEvent.relatedTarget) {
            postId = LadiesMain._getHashtagObject()["post-id"]
            starId = LadiesMain._getHashtagObject()["star-id"]
        } else {
            postId = modalEvent.relatedTarget.dataset.postId
            starId = modalEvent.relatedTarget.dataset.starId
        }

        try {
            this.updateBuyRosesModalWithCreatorData(postId, starId)

            LadiesMain.addHashtagToUrl("configure-roses-modal")

            if (postId) {
                LadiesMain.addHashtagToUrl("post-id", postId)
            }

            if (starId) {
                LadiesMain.addHashtagToUrl("star-id", starId)
            }
        } catch (e) {
            this.clearUrl()
            modalEvent.preventDefault()
            openGenericModal(
                "Die gewünschte Aktion ist nicht möglich.\n" +
                    "                            Lade bitte die Seite neu und versuche es erneut.\n" +
                    "                            Sollte es weiterhin nicht funktionieren, melde dich bitte bei unserem Support.",
                "Unzulässiger Vorgang",
            )
        }
    }

    toggleSubscriptionModalBuyButtonsContent(/** jQuery.Event */ modalEvent) {
        const ownerId = modalEvent.relatedTarget.value

        for (const button of Array.from(this.rosesModalBuyButtons.querySelectorAll("button"))) {
            button.value = ownerId
        }

        this.updateSubscriptionModalWithCreatorData(ownerId)
    }

    updateSubscriptionModalWithCreatorData(ownerId) {
        const creatorContainer = document.getElementById(`stars-roses-${ownerId}`)
        if (!creatorContainer) {
            return
        }

        const creatorName = creatorContainer.getElementsByClassName("creatorProfileName")[0].innerHTML
        const creatorAvatarSrc = creatorContainer.getElementsByClassName("creatorProfileAvatar")[0].getAttribute("src")
        for (const subscriptionModal of document.getElementsByClassName("stars-roses-modal")) {
            if (subscriptionModal instanceof HTMLElement) {
                subscriptionModal
                    .getElementsByClassName("creatorProfileAvatar")[0]
                    .setAttribute("src", creatorAvatarSrc)
                subscriptionModal.getElementsByClassName("creatorProfileName")[0].innerHTML = creatorName
            }
        }
    }

    getActualRosesCountForPost(postId) {
        let actual_rose_amount = Number.parseInt(
            document.querySelector(`.gift-roses-button[data-post-id="${postId}"]`).querySelector(".rose-count")
                .innerText,
        )
        if (Number.isNaN(actual_rose_amount) || actual_rose_amount <= 0) {
            actual_rose_amount = 0
        }

        return actual_rose_amount
    }

    setUnsetOpenStarsModalClass(/** jQuery.Event */ modalEvent) {
        const starsModalClass = "stars-modal-open"

        if (modalEvent.type === "show") {
            document.body.classList.add(starsModalClass)
        } else {
            document.body.classList.remove(starsModalClass)
        }
    }

    async purchaseRosesRequestInStarsSeparation(/** Event */ event) {
        try {
            const loaderImageSource = "https://static.ladies-cdn.de/shared/ladies/img/loader-white.gif"

            event.srcElement.innerHTML = `<img class="mx-2" src="${loaderImageSource}" alt="" /><span>&nbsp;&nbsp;&nbsp;Bitte warten...</span>`

            const coin_amount = Number.parseInt(event.currentTarget.dataset.coin_amount)
            const rose_amount = Number.parseInt(event.currentTarget.dataset.rose_amount)
            const post_id = LadiesMain._getHashtagObject()["post-id"] || null
            const ownerId = LadiesMain._getHashtagObject()["star-id"]

            const body = {
                amount: rose_amount,
                creatorId: ownerId,
            }

            let starsSeparationRosesApiUrl = this.starsSeparationRosesApiUrForCreator

            if (post_id) {
                body.postId = post_id
                starsSeparationRosesApiUrl = this.starsSeparationRosesApiUrForPost
            }

            const request = await fetch(starsSeparationRosesApiUrl, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${userData.accessToken}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(body),
            })

            const result = await request

            if (result.ok) {
                const newCoinBalance = this.userCurrentCoinBalanceInDom() - coin_amount
                this.saveCurrentCoinBalanceInStorage(newCoinBalance)

                this.closeRosesModalAndClearState()

                this.displayRosesPurchasedMessage(
                    rose_amount,
                    document.querySelector(`.creatorProfileName[data-creator-id='${ownerId}']`).dataset.creatorName,
                )

                if (post_id) {
                    this.changeStateToRosesGiftedToPost(post_id, rose_amount)
                }
            } else {
                // TODO: Protocol-Logger

                this.closeRosesModalAndClearState()

                throw new Error(
                    this.mapErrorResponse(
                        document.querySelector(`.creatorProfileName[data-creator-id='${ownerId}']`).dataset.creatorName,
                        result,
                    ),
                )
            }
        } catch (e) {
            // TODO: Protocol-Logger
            this.handleRosesRejected(e)

            this.closeRosesModalAndClearState()
        }
    }

    async purchaseRosesRequest(event) {
        try {
            const loaderImageSource = "https://static.ladies-cdn.de/shared/ladies/img/loader-white.gif"

            event.srcElement.innerHTML = `<img class="mx-2" src="${loaderImageSource}" alt="" /><span>&nbsp;&nbsp;&nbsp;Bitte warten...</span>`

            const coin_amount = Number.parseInt(event.currentTarget.dataset.coin_amount)
            const rose_amount = Number.parseInt(event.currentTarget.dataset.rose_amount)
            const post_id = LadiesMain._getHashtagObject()["post-id"] || null
            const ownerId = LadiesMain._getHashtagObject()["star-id"]
            let actual_rose_amount = 0

            if (post_id) {
                actual_rose_amount = this.getActualRosesCountForPost(post_id)
            }

            this.rosesFormData.set("creatorId", ownerId)
            this.rosesFormData.set("rose_amount", rose_amount)
            this.rosesFormData.set("actual_rose_amount", actual_rose_amount)
            this.rosesFormData.set("coin_amount", coin_amount)
            this.rosesFormData.set("post_id", post_id)

            let result = await fetch(this.rosesApiUrl, {
                method: "POST",
                body: this.rosesFormData,
                credentials: "include",
            })

            result = await result.json()

            if (result.message === "success") {
                const newCoinBalance = this.userCurrentCoinBalanceInDom() - coin_amount
                this.saveCurrentCoinBalanceInStorage(newCoinBalance)

                this.closeRosesModalAndClearState()

                this.displayRosesPurchasedMessage(
                    rose_amount,
                    document.querySelector(`.creatorProfileName[data-creator-id='${ownerId}']`).dataset.creatorName,
                )

                if (post_id) {
                    this.changeStateToRosesGiftedToPost(post_id, rose_amount)
                }
            } else {
                // TODO: Protocol-Logger

                this.closeRosesModalAndClearState()

                throw new Error(
                    this.mapErrorResponse(
                        document.querySelector(`.creatorProfileName[data-creator-id='${ownerId}']`).dataset.creatorName,
                        result,
                    ),
                )
            }
        } catch (e) {
            // TODO: Protocol-Logger
            this.handleRosesRejected(e)

            this.closeRosesModalAndClearState()
        }
    }

    closeRosesModalAndClearState() {
        LadiesMain.removeHashtagFromUrl("purchase-roses-modal")
        this.clearUrl()

        this.closePurchaseRosesModal()

        if (this.purchaseRosesButton) {
            this.purchaseRosesButton.innerHTML = this.rosesBuyButtonStandardTextTmp
        }

        this.rosesFormData = new FormData()
        this.rosesCountInput.value = 0
        this.updateCoinsCount()
    }

    displayRosesPurchasedMessage(rosesCount, starName) {
        let dynamicPart = `deine ${rosesCount} Rosen`
        if (rosesCount === 1) {
            dynamicPart = "deine Rose"
        }

        const subscriptionMessage = `${starName}: "Vielen Dank für ${dynamicPart}!"`

        window.setTimeout(() => {
            InfoPanel.displayMessage(subscriptionMessage, InfoPanel.Type.Star)
        }, 10)
    }

    continueToBuyRoses() {
        let rosesCount = Number.parseInt(this.rosesCountInput.value, 10)
        const userCurrentCoins = this.userCurrentCoinBalanceInDom()

        if (Number.isNaN(rosesCount)) {
            rosesCount = 0
        }

        if (Number.isNaN(rosesCount) || rosesCount <= 0) {
            document.getElementById("subscriptionPrice").innerHTML = "0" + " Coins"
            document.getElementById("rosesTitle").innerHTML = "0" + " Rosen: "
            if (this.purchaseRosesButton) {
                this.purchaseRosesButton.style.display = "none"
            }
            document.getElementById("notEnoughCoins").style.display = "none"
            document.getElementById("userNotEnoughCoins").innerHTML = ""
        } else {
            document.getElementById("subscriptionPrice").innerHTML = `${this.getRosesPriceInCoins(rosesCount)} Coins`

            let rosesLabel = `${rosesCount} Rosen`
            if (rosesCount === 1) {
                rosesLabel = "Eine Rose"
            }
            document.getElementById("rosesTitle").innerHTML = `${rosesLabel}: `

            const priceInCoins = this.getRosesPriceInCoins(rosesCount)
            if (userCurrentCoins >= priceInCoins) {
                if (this.purchaseRosesButton) {
                    this.purchaseRosesButton.style.display = "block"
                    this.purchaseRosesButton.dataset.rose_amount = rosesCount
                    this.purchaseRosesButton.dataset.coin_amount = priceInCoins
                }
                document.getElementById("notEnoughCoins").style.display = "none"
                document.getElementById("userNotEnoughCoins").innerHTML = ""
            } else {
                if (this.purchaseRosesButton) {
                    this.purchaseRosesButton.style.display = "none"
                }
                document.getElementById("notEnoughCoins").style.display = "block"
                document.getElementById("userNotEnoughCoins").innerHTML = "(nicht ausreichend)"
            }
        }
    }

    addOrSubstractRosesCount(event) {
        const action = event.currentTarget.dataset.action
        let rosesCount = Number.parseInt(this.rosesCountInput.value, 10)

        if (Number.isNaN(rosesCount)) {
            rosesCount = 0
        }

        if (action === "add") {
            rosesCount = rosesCount + 1
        } else if (action === "substract") {
            rosesCount = rosesCount - 1

            if (rosesCount < 0) {
                rosesCount = 0
            }
        }

        this.rosesCountInput.value = rosesCount

        this.updateCoinsCount()
    }

    updateBuyRosesModalWithCreatorData(postId, starId) {
        let creatorAvatarSrc
        if (postId) {
            const starBox = document.getElementById(`post-${postId}`)
            if (starBox) {
                creatorAvatarSrc = starBox.getElementsByClassName("profil-icon")[0].getAttribute("src")
            }
        } else {
            creatorAvatarSrc = document.getElementById("stars-profile-avatar").getAttribute("src")
        }

        if (this.buyRosesModal instanceof HTMLElement) {
            this.buyRosesModal.getElementsByClassName("creatorProfileAvatar")[0].setAttribute("src", creatorAvatarSrc)
            // subscriptionModal.getElementsByClassName('creatorProfileName')[0].innerHTML = creatorName;
        }

        if (starId) {
            for (const starNameElement of document.getElementsByClassName("starName")) {
                if (starNameElement instanceof HTMLElement) {
                    starNameElement.innerHTML = document.querySelector(
                        `.creatorProfileName[data-creator-id='${starId}']`,
                    ).dataset.creatorName
                }
            }
        }
    }

    updateCoinsCount() {
        let rosesCount = Number.parseInt(this.rosesCountInput.value)

        this.hideNotEnoughCoinsInfo()

        if (Number.isNaN(rosesCount)) {
            this.safeSetHTML("userCoinBalance", " ")
            this.disableContinueToBuyRosesButton()

            LadiesMain.removeHashtagFromUrl("roses-count")
        } else if (rosesCount <= 0) {
            this.safeSetHTML("userCoinBalance", " ")
            this.disableContinueToBuyRosesButton()

            LadiesMain.removeHashtagFromUrl("roses-count")
        } else {
            let priceInCoins = this.getRosesPriceInCoins(rosesCount)
            const userCurrentCoins = this.userCurrentCoinBalanceInDom()

            if (priceInCoins > userCurrentCoins) {
                this.showNotEnoughCoinsInfo()

                if (this.coinsCountExeeded(rosesCount)) {
                    rosesCount = this.getRosesCountFromCoins(this.maximalCoinsForUser())
                    priceInCoins = this.getRosesPriceInCoins(rosesCount)
                    this.rosesCountInput.value = rosesCount
                }
            }

            this.safeSetHTML("userCoinBalance", `${priceInCoins} Coins`)
            document.getElementById("continueToBuyRosesButton").disabled = false

            LadiesMain.addHashtagToUrl("roses-count", rosesCount)
        }
    }

    safeSetHTML(id, value) {
        const el = document.getElementById(id)
        if (el) el.innerHTML = value
    }

    disableContinueToBuyRosesButton() {
        const continueToBuyRosesButton = document.getElementById("continueToBuyRosesButton")
        if (continueToBuyRosesButton !== null) {
            continueToBuyRosesButton.disabled = true
        }
    }

    showNotEnoughCoinsInfo() {
        for (const element of document.getElementsByClassName("user-not-enough-coins")) {
            if (element instanceof HTMLElement) {
                element.style.display = "inline-block"
            }
        }
    }

    hideNotEnoughCoinsInfo() {
        for (const element of document.getElementsByClassName("user-not-enough-coins")) {
            if (element instanceof HTMLElement) {
                element.style.display = "none"
            }
        }
    }

    getRosesPriceInCoins(rosesCount) {
        return 50 * rosesCount
    }

    getRosesCountFromCoins(coins) {
        return coins / 50
    }

    maximalCoinsForUser() {
        const biggestCoinsPacket = 27500

        return this.userCurrentCoinBalanceInDom() + biggestCoinsPacket
    }

    coinsCountExeeded(rosesCount) {
        if (this.getRosesPriceInCoins(rosesCount) > this.maximalCoinsForUser()) {
            return true
        }

        return false
    }

    reopenModals() {
        if (LadiesMain.checkHashtagInUrl("purchase-roses-modal")) {
            $(this.buyRosesModal).modal("show")

            if (LadiesMain.checkHashtagInUrl("roses-count")) {
                this.rosesCountInput.value = Number.parseInt(LadiesMain._getHashtagObject()["roses-count"])
                this.updateCoinsCount()
            }

            this.continueToBuyRoses()
        } else if (LadiesMain.checkHashtagInUrl("configure-roses-modal")) {
            $(this.configureRosesModal).modal("show")

            if (LadiesMain.checkHashtagInUrl("roses-count")) {
                this.rosesCountInput.value = Number.parseInt(LadiesMain._getHashtagObject()["roses-count"])
                this.updateCoinsCount()
            }
        }
    }

    closePurchaseRosesModal() {
        $(this.buyRosesModal).modal("hide")
    }

    userCurrentCoinBalanceInDom(/** number*/ newCoinBalance) {
        if (typeof newCoinBalance !== "undefined") {
            this.currentCoins = newCoinBalance
        }

        const userCoinBalanceRoses = document.getElementById("userCoinBalanceRoses")
        if (userCoinBalanceRoses) {
            userCoinBalanceRoses.innerHTML = this.currentCoins.toString()
        }

        const userCoinBalanceRosesToBuy = document.getElementById("userCoinBalanceRosesToBuy")
        if (userCoinBalanceRosesToBuy) {
            userCoinBalanceRosesToBuy.innerHTML = this.currentCoins.toString()
        }

        return this.currentCoins
    }

    saveCurrentCoinBalanceInStorage(/** number */ coinBalance) {
        /** void */
        this.userCurrentCoinBalanceInDom(coinBalance)

        localStorage.setItem("userCurrentCoinBalance", coinBalance)
    }

    listenForRosesInteraction(/** HTMLElement */ post) {
        // Listen for click on post itself in case loading
        // was not yet complete (for dynamically added posts)
        post.addEventListener(
            "click",
            (clickEvent) => {
                const rosesButton = clickEvent.target.closest(".gift-roses-button")

                if (rosesButton === null) {
                    // Jump out if click on post was not triggered by roses-button
                    return
                }

                this.isUnableToChangeRoseState(rosesButton)
            },
            {
                // Passive makes sure the event doesn't affect performance
                passive: true,
            },
        )
    }

    handleRosesRejected(/** Error */ reason) {
        /** void */
        if (reason.message === "") {
            return
        }

        openGenericModal(reason.message, "Jetzt Rosen schenken")
    }

    mapErrorResponse(/** string **/ starName, /** Response **/ response) {
        /** string */
        const mappingKey = response.message || response.error_message || "Es ist ein unbekannter Fehler aufgetreten"

        switch (mappingKey) {
            case "no post found": {
                const postId = response["post-id"] || null
                if (postId) {
                    document.getElementById(`post-${postId}`).remove()
                }

                return `Leider wurde dieser Beitrag in der Zwischenzeit entfernt. ${starName} freut sich über deine Rosen bei einem anderen Beitrag`
            }

            case "userId is missing":
            case "postId is missing":
            case "creatorId is missing":
                return "Bei dieser Aktion ist ein Problem aufgetreten. Lade die Seite neu und versuche es bitte erneut."

            case "unknown type":
                return "Die gewünschte Aktion wurde ausgeführt, ist allerdings von einem unbekannten Typ. Bitte lade die Seite neu."

            case "not logged in":
                return "Wir konnten nicht sicherstellen, dass du angemeldet bist. Bitte lade die Seite neu und versuche es noch einmal."

            case "not subscribed":
                return "Du bist kein Fan mehr."

            default:
                return mappingKey
        }
    }

    isUnableToChangeRoseState(/** HTMLElement */ rosesButton) {
        /** boolean */
        if (rosesButton.hasAttribute("data-toggle")) {
            // Jump out if modals should be toggled because user is not logged in, not age verified or not a fan
            return true
        }

        if (typeof userData === "undefined" || userData.userId === undefined || userData.isLoggedIn === undefined) {
            InfoPanel.displayMessage(
                "Wir können deinen Benutzerstatus nicht ermitteln. Versuche bitte die Seite neuzuladen oder dich neu anzumelden.",
                InfoPanel.Type.Error,
            )
            return true
        }

        if (userData.userId === "0" || !userData.isLoggedIn) {
            // If we reach this point, personalisation didn't work, so try opening modal here
            LadiesMain.showLoginModal()
            return true
        }

        return !!rosesButton.closest(".stars-post").querySelector('data[value="unpaid"]')
    }
}
